<template>
    <span>{{ format.format(text || '') }}</span>
</template>
<script>
import { computed } from 'vue'
export default {
    name: 'TextColumn',
    props: {
        prop: {
            type: String,
            required: true,
        },
        row: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
        view: {
            type: Object,
            default:()=>({})
        },
        format: {
            type: Object,
            default: () => ({ format: (v) => v })
        }
    },
    setup(props) {
        const text = computed(() => props?.row?.[props.prop] || '')

        return {
            text
        }
    }
}
</script>
<style lang="scss">

</style>